/**
 * The Patient Workspace's primary tabs and the deep-link rule — pure, so a
 * link into any artifact lands on the right tab without hunting.
 */

/**
 * `plans` keeps its key for backward-compatible links: it is the Packages &
 * Payments tab. `care-plan` (ZOY-667) is the Plan-service care plan the
 * connected family sees; `family` (ZOY-665) is the record's family connection.
 */
export const RECORD_TABS = [
  'overview',
  'clinical',
  'sessions',
  'care-plan',
  'family',
  'plans',
  'details',
] as const;
export type RecordTab = (typeof RECORD_TABS)[number];

/** `?tab=` from the URL; anything unknown (or absent) is Overview. */
export function recordTabOf(value: unknown): RecordTab {
  return typeof value === 'string' && (RECORD_TABS as readonly string[]).includes(value)
    ? (value as RecordTab)
    : 'overview';
}

export type RecordArtifact =
  | 'intake'
  | 'assessment'
  | 'instrument'
  | 'booking'
  | 'session'
  | 'package'
  | 'payments'
  | 'caregivers'
  | 'history';

/** Which tab an artifact lives on — the back-link target from its own page. */
export function tabForArtifact(kind: RecordArtifact): RecordTab {
  switch (kind) {
    case 'intake':
    case 'assessment':
    case 'instrument':
      return 'clinical';
    case 'booking':
    case 'session':
      return 'sessions';
    case 'package':
    case 'payments':
      return 'plans';
    case 'caregivers':
    case 'history':
      return 'details';
  }
}
